import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import PublicSite, { LandingRoute } from "@/pages/PublicMenu";
import MenuPage from "@/pages/MenuPage";
import Preview from "@/pages/Preview";
import AdminApp from "@/admin/AdminApp";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PublicSite />}>
          <Route path="/" element={<LandingRoute />} />
          <Route path="/menu/:slug" element={<MenuPage />} />
        </Route>
        <Route path="/preview" element={<Preview />}>
          <Route index element={<LandingRoute />} />
          <Route path="menu/:slug" element={<MenuPage />} />
        </Route>
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster theme="dark" position="top-center" richColors />
    </BrowserRouter>
  );
}
